// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1PZk6","title":"ClientInsurance_title__3EVuf","itemText":"ClientInsurance_itemText__1TpeP"};